"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDeleteConfirmModal = void 0;
var tslib_1 = require("tslib");
var modal_form_component_1 = require("../../components/modal.form/modal.form.component");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var FormDeleteConfirmModal = /** @class */ (function (_super) {
    tslib_1.__extends(FormDeleteConfirmModal, _super);
    function FormDeleteConfirmModal(ctx, formSummary) {
        var _this = _super.call(this, ctx) || this;
        _this.formSummary = formSummary;
        return _this;
    }
    Object.defineProperty(FormDeleteConfirmModal.prototype, "nodes", {
        get: function () {
            return (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.FORM_DELETE_CONFIRM, { name: this.formSummary.displayname }));
        },
        enumerable: false,
        configurable: true
    });
    FormDeleteConfirmModal.prototype.submit = function () {
        return services_1.Services.Form.remove(this.formSummary.uuid);
    };
    return FormDeleteConfirmModal;
}(modal_form_component_1.ModalFormComponent));
exports.FormDeleteConfirmModal = FormDeleteConfirmModal;
//# sourceMappingURL=form.delete.confirm.modal.js.map